import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { AxiosError } from 'axios';
import { useContext, useContextSelector } from 'use-context-selector';
import { CheckMandateResponseBody } from '../../../../authorizations/src/domain/Authorization/entities/CheckMandateResponseDTO';
import { ConsolidatedTransactionDetails } from '../../domain/Transaction/entities/ConsolidatedTransaction';
import { AccountExtraitTransactionDetailsContext } from './AccountExtraitTransactionDetailsContext';

const useTransactionsState = () => {
  const context = useContext(AccountExtraitTransactionDetailsContext);

  if (context === undefined) {
    throw new Error('useTransactionsState must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useAccountExtraitTransactionDetails = () => {
  const context = useContextSelector(
    AccountExtraitTransactionDetailsContext,
    state => state.accountExtraitTransactionDetailsData,
  );

  // if (context === undefined) {
  //   throw new Error('useAccountExtraitTransactionDetails must be used within AccountExtraitTransactionsProvider');
  // }

  return context;
};

const useSelectedAccountExtraitTransaction = () => {
  const context = useContextSelector(
    AccountExtraitTransactionDetailsContext,
    state => state.selectedAccountExtraitTransaction,
  );

  if (context === undefined) {
    throw new Error('useAccountExtraitSelectedTransaction must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useOnSelectAccountExtraitTransaction = (): ((transactionNo?: string | undefined) => void) => {
  const context = useContextSelector(
    AccountExtraitTransactionDetailsContext,
    state => state.onSelectAccountExtraitTransaction,
  );

  if (context === undefined) {
    throw new Error('useOnSelectAccountExtraitTransaction must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useResetSelectedAccountExtraitTransaction = () => {
  const context = useContextSelector(
    AccountExtraitTransactionDetailsContext,
    state => state.resetSelectedAccountExtraitTransaction,
  );

  if (context === undefined) {
    throw new Error('useResetSelectedAccountExtraitTransaction must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useOnAccountExtraitDetailsMutation = () => {
  const context = useContextSelector(
    AccountExtraitTransactionDetailsContext,
    state => state.onAccountExtraitDetailsMutation,
  );

  if (context === undefined) {
    throw new Error('useOnAccountExtraitDetailsMutation must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useCheckAuthorization = () =>
  useContextSelector(AccountExtraitTransactionDetailsContext, state => state.checkAuthorizationData);

const useOnCheckAuthorizationMutation = () => {
  const context = useContextSelector(
    AccountExtraitTransactionDetailsContext,
    state => state.onCheckAuthorizationMutation,
  );

  if (context === undefined) {
    throw new Error('useOnCheckAuthorizationMutation must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useAccountExtraitTransactionsProviderLoadingState = (
  loadingProperty: 'isLoadingAccountExtraitTransactionDetails' | 'isLoadingCheckAuthorization',
) => {
  const context = useContextSelector(AccountExtraitTransactionDetailsContext, state => state[loadingProperty]);

  if (context === undefined) {
    throw new Error('useTransactionLoadingState must be used within AccountExtraitTransactionsProvider');
  }

  return context;
};

const useAccountExtraitTransactionsProviderErrorState = (
  errorProperty: 'accountExtraitTransactionDetailsError' | 'checkAuthorizationError',
): AxiosError<APIGatewayResponse<ConsolidatedTransactionDetails | CheckMandateResponseBody>, any> | undefined =>
  useContextSelector(AccountExtraitTransactionDetailsContext, state => state[errorProperty]);

export {
  useOnCheckAuthorizationMutation,
  useCheckAuthorization,
  useTransactionsState,
  useSelectedAccountExtraitTransaction,
  useAccountExtraitTransactionDetails,
  useOnSelectAccountExtraitTransaction,
  useAccountExtraitTransactionsProviderLoadingState,
  useAccountExtraitTransactionsProviderErrorState,
  useResetSelectedAccountExtraitTransaction,
  useOnAccountExtraitDetailsMutation,
};
